import styled, { css } from 'styled-components/macro';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { RegularTextLevel4 } from '@yme/tokens/typography';
const commonStyled = css `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;
export const SignInMenuItemStyled = styled.span `
  // TODO: (D.K.) Need update style with remove flag '!important'
  padding: ${({ isAuthorized }) => (isAuthorized ? '0 8px !important' : '8px')};

  & > [data-class-overflow-menu] {
    padding-top: 8px;
  }
`;
export const AuthorizedSingCircle = styled(RegularTextLevel4) `
  ${commonStyled};
  bottom: 0;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  color: ${colorCoreWhite1000};
`;
export const IframeStyle = styled.iframe `
  ${commonStyled};

  margin: 0 auto;
  width: 100%;
  border: 0;
  height: 100%;
  opacity: 0;
`;
